"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var protocol_http_1 = require("@aws-sdk/protocol-http");

var request_timeout_1 = require("./request-timeout");

var querystring_builder_1 = require("@aws-sdk/querystring-builder");

var FetchHttpHandler =
/** @class */
function () {
  function FetchHttpHandler(httpOptions) {
    if (httpOptions === void 0) {
      httpOptions = {};
    }

    this.httpOptions = httpOptions;
  }

  FetchHttpHandler.prototype.destroy = function () {// Do nothing. TLS and HTTP/2 connection pooling is handled by the
    // browser.
  };

  FetchHttpHandler.prototype.handle = function (request, options) {
    var abortSignal = options === null || options === void 0 ? void 0 : options.abortSignal;
    var requestTimeoutInMs = this.httpOptions.requestTimeout; // if the request was already aborted, prevent doing extra work

    if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
      var abortError = new Error("Request aborted");
      abortError.name = "AbortError";
      return Promise.reject(abortError);
    }

    var path = request.path;

    if (request.query) {
      var queryString = querystring_builder_1.buildQueryString(request.query);

      if (queryString) {
        path += "?" + queryString;
      }
    }

    var port = request.port;
    var url = request.protocol + "//" + request.hostname + (port ? ":" + port : "") + path;
    var requestOptions = {
      body: request.body,
      headers: new Headers(request.headers),
      method: request.method,
      mode: "cors"
    }; // some browsers support abort signal

    if (typeof AbortController !== "undefined") {
      requestOptions["signal"] = abortSignal;
    }

    var fetchRequest = new Request(url, requestOptions);
    var raceOfPromises = [fetch(fetchRequest).then(function (response) {
      var e_1, _a;

      var fetchHeaders = response.headers;
      var transformedHeaders = {};

      try {
        for (var _b = tslib_1.__values(fetchHeaders.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
          var pair = _c.value;
          transformedHeaders[pair[0]] = pair[1];
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }

      var hasReadableStream = response.body !== undefined; // Return the response with buffered body

      if (!hasReadableStream) {
        return response.blob().then(function (body) {
          return {
            response: new protocol_http_1.HttpResponse({
              headers: transformedHeaders,
              statusCode: response.status,
              body: body
            })
          };
        });
      } // Return the response with streaming body


      return {
        response: new protocol_http_1.HttpResponse({
          headers: transformedHeaders,
          statusCode: response.status,
          body: response.body
        })
      };
    }), request_timeout_1.requestTimeout(requestTimeoutInMs)];

    if (abortSignal) {
      raceOfPromises.push(new Promise(function (resolve, reject) {
        abortSignal.onabort = function () {
          var abortError = new Error("Request aborted");
          abortError.name = "AbortError";
          reject(abortError);
        };
      }));
    }

    return Promise.race(raceOfPromises);
  };

  return FetchHttpHandler;
}();

exports.FetchHttpHandler = FetchHttpHandler;